type IconTargetPayloadTarget = "cf-frame"

export type IconTargetPayload<T extends IconTargetPayloadTarget> = {
    targetId: string
    target: T
}

export interface ColorFinderIconTargetPayload extends IconTargetPayload<"cf-frame"> {
    frame: number
}

interface TargetPayloadMap {
    ["cf-frame"]: ColorFinderIconTargetPayload
}

export const parseIconTargetPayload = <T extends IconTargetPayloadTarget>(
    payload: string | undefined
) => {
    return payload === undefined ? payload : (JSON.parse(payload) as TargetPayloadMap[T])
}
